import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { cropIllustration } from '@/lib/cropIllustrations';
import { cropLabel } from '@/lib/cropLabels';
import { useLang } from '@/i18n/LanguageContext';
import { Sprout } from 'lucide-react';
let catalogPromise;
export default function CropIdentity({ cropId, name }) {
 const { lang } = useLang(); const [row, setRow] = useState(null);
 useEffect(() => {
  let active=true;
  if (!catalogPromise) catalogPromise=api.get('/references/catalog').then(r=>r.data.crops).catch(()=>{catalogPromise=null;return [];});
  catalogPromise.then(rows=>{if(active)setRow(rows.find(r=>r.crop_id===cropId || r.merged_ids?.includes(cropId) || r.label_en===name || r.label_it===name));});
  return ()=>{active=false;};
 },[cropId,name]);
 return <span className="inline-flex items-center gap-2">{row ? <img src={cropIllustration(row)} alt="" width="40" height="40" className="w-10 h-10 object-contain shrink-0" /> : <Sprout size={20} className="text-[#557448]" />}{row ? cropLabel(row,lang) : name}</span>;
}
